// Renders a non-available capability as a stable, explained fact.
//
// The whole point of this component is that a disabled control in the
// handoff UI can never appear without its exact reason next to it: the
// reason is a required field on every non-`available` capability in the
// contract, and this is the only component that renders one. There is no
// "generic disabled" path anywhere in the handoff surface.
//
// `reason` text comes from the daemon (capabilities.ts), transcribed from
// the integration ledger, so the UI cannot drift into a friendlier or
// vaguer claim than the ledger supports.

import type { GiniHandoffCapability } from '@open-design/contracts/gini-platform';
import styles from './HandoffLanding.module.css';

interface Props {
  capability: GiniHandoffCapability;
  /** Test/query hook so specs can target one specific notice. */
  testId?: string;
}

export function CapabilityNotice({ capability, testId }: Props) {
  if (capability.state === 'available') return null;
  return (
    <div className={styles.notice} role="note" data-testid={testId} data-capability-state={capability.state}>
      {capability.reason}
      {capability.reference ? <span className={styles.noticeReference}>{capability.reference}</span> : null}
    </div>
  );
}
